import React from 'react'
import '../cta/cta.css'

const Cta = () => {
  return (
    <div className='barry__cta'>
      <div className='barry__cta-content'>
        <p>Request Early Access to Get Started</p>
        <h3>Register today &amp; start exploring the endless possiblities.</h3>
      </div>
      <div className='barry__cta-btn'>
        <button type='button'>Get Started</button>
      </div>
    </div>
  )
}

export default Cta
